(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function polar(cx, cy, r, angleDeg) {
      var rad = (angleDeg * Math.PI) / 180;
      return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
    }

    function describeArc(cx, cy, r, a0, a1) {
      var start = polar(cx, cy, r, a0);
      var end = polar(cx, cy, r, a1);
      var largeArc = a1 - a0 > 180 ? 1 : 0;
      return ['M', start.x, start.y, 'A', r, r, 0, largeArc, 1, end.x, end.y].join(' ');
    }

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function initDial(root) {
      var svg = root.querySelector('.temp-dial__svg');
      var track = root.querySelector('.temp-dial__track');
      var fill = root.querySelector('.temp-dial__fill');
      var handle = root.querySelector('.temp-dial__handle');
      var valueEl = root.querySelector('.temp-dial__value');
      var badge = root.querySelector('.temp-dial-widget__badge');
      var textEls = root.querySelectorAll('[data-zone-text]');

      var min = parseFloat(root.dataset.min);
      var max = parseFloat(root.dataset.max);
      var coldMax = parseFloat(root.dataset.coldMax);
      var heatMin = parseFloat(root.dataset.heatMin);
      var current = parseFloat(root.dataset.default);

      var cx = 150;
      var cy = 150;
      var r = 120;
      var startAngle = 135;
      var sweep = 270;
      var dragging = false;

      track.setAttribute('d', describeArc(cx, cy, r, startAngle, startAngle + sweep));

      function tempToAngle(t) {
        var f = (t - min) / (max - min);
        return startAngle + f * sweep;
      }

      function angleToTemp(rel) {
        return min + (rel / sweep) * (max - min);
      }

      function render(t) {
        current = clamp(t, min, max);
        var angle = tempToAngle(current);

        fill.setAttribute('d', describeArc(cx, cy, r, startAngle, angle));

        var pos = polar(cx, cy, r, angle);
        handle.setAttribute('cx', pos.x);
        handle.setAttribute('cy', pos.y);
        handle.setAttribute('aria-valuenow', Math.round(current));

        valueEl.textContent = Math.round(current);

        var zone = current <= coldMax ? 'cold' : current >= heatMin ? 'heat' : 'neutral';

        textEls.forEach(function (el) {
          el.hidden = el.getAttribute('data-zone-text') !== zone;
        });

        if (badge) {
          badge.textContent = badge.getAttribute('data-label-' + zone) || '';
          badge.setAttribute('data-active-zone', zone);
        }
      }

      function angleFromPoint(clientX, clientY) {
        var rect = svg.getBoundingClientRect();
        var scale = 300 / rect.width;
        var x = (clientX - rect.left) * scale - cx;
        var y = (clientY - rect.top) * scale - cy;
        var deg = (Math.atan2(y, x) * 180) / Math.PI;
        if (deg < 0) deg += 360;

        var rel = deg - startAngle;
        if (rel < 0) rel += 360;

        if (rel > sweep) {
          var gapCenter = sweep + (360 - sweep) / 2;
          rel = rel < gapCenter ? sweep : 0;
        }

        return rel;
      }

      function handlePointer(event) {
        var point = event.touches ? event.touches[0] : event;
        render(angleToTemp(angleFromPoint(point.clientX, point.clientY)));
      }

      function startDrag(event) {
        dragging = true;
        handlePointer(event);
        event.preventDefault();
      }

      function moveDrag(event) {
        if (!dragging) return;
        handlePointer(event);
      }

      function endDrag() {
        dragging = false;
      }

      handle.addEventListener('pointerdown', startDrag);
      track.addEventListener('pointerdown', startDrag);
      fill.addEventListener('pointerdown', startDrag);
      window.addEventListener('pointermove', moveDrag);
      window.addEventListener('pointerup', endDrag);

      handle.addEventListener('keydown', function (event) {
        var step = 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
          render(current + step);
          event.preventDefault();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
          render(current - step);
          event.preventDefault();
        } else if (event.key === 'Home') {
          render(min);
          event.preventDefault();
        } else if (event.key === 'End') {
          render(max);
          event.preventDefault();
        }
      });

      render(current);
    }

    document.querySelectorAll('.temp-dial-widget').forEach(initDial);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function polar(cx, cy, r, angleDeg) {
      var rad = (angleDeg * Math.PI) / 180;
      return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
    }

    function describeArc(cx, cy, r, a0, a1) {
      var start = polar(cx, cy, r, a0);
      var end = polar(cx, cy, r, a1);
      var largeArc = a1 - a0 > 180 ? 1 : 0;
      return ['M', start.x, start.y, 'A', r, r, 0, largeArc, 1, end.x, end.y].join(' ');
    }

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function initDial(root) {
      var svg = root.querySelector('.temp-dial__svg');
      var track = root.querySelector('.temp-dial__track');
      var fill = root.querySelector('.temp-dial__fill');
      var handle = root.querySelector('.temp-dial__handle');
      var valueEl = root.querySelector('.temp-dial__value');
      var badge = root.querySelector('.temp-dial-widget__badge');
      var textEls = root.querySelectorAll('[data-zone-text]');

      var min = parseFloat(root.dataset.min);
      var max = parseFloat(root.dataset.max);
      var coldMax = parseFloat(root.dataset.coldMax);
      var heatMin = parseFloat(root.dataset.heatMin);
      var current = parseFloat(root.dataset.default);

      var cx = 150;
      var cy = 150;
      var r = 120;
      var startAngle = 135;
      var sweep = 270;
      var dragging = false;

      track.setAttribute('d', describeArc(cx, cy, r, startAngle, startAngle + sweep));

      function tempToAngle(t) {
        var f = (t - min) / (max - min);
        return startAngle + f * sweep;
      }

      function angleToTemp(rel) {
        return min + (rel / sweep) * (max - min);
      }

      function render(t) {
        current = clamp(t, min, max);
        var angle = tempToAngle(current);

        fill.setAttribute('d', describeArc(cx, cy, r, startAngle, angle));

        var pos = polar(cx, cy, r, angle);
        handle.setAttribute('cx', pos.x);
        handle.setAttribute('cy', pos.y);
        handle.setAttribute('aria-valuenow', Math.round(current));

        valueEl.textContent = Math.round(current);

        var zone = current <= coldMax ? 'cold' : current >= heatMin ? 'heat' : 'neutral';

        textEls.forEach(function (el) {
          el.hidden = el.getAttribute('data-zone-text') !== zone;
        });

        if (badge) {
          badge.textContent = badge.getAttribute('data-label-' + zone) || '';
          badge.setAttribute('data-active-zone', zone);
        }
      }

      function angleFromPoint(clientX, clientY) {
        var rect = svg.getBoundingClientRect();
        var scale = 300 / rect.width;
        var x = (clientX - rect.left) * scale - cx;
        var y = (clientY - rect.top) * scale - cy;
        var deg = (Math.atan2(y, x) * 180) / Math.PI;
        if (deg < 0) deg += 360;

        var rel = deg - startAngle;
        if (rel < 0) rel += 360;

        if (rel > sweep) {
          var gapCenter = sweep + (360 - sweep) / 2;
          rel = rel < gapCenter ? sweep : 0;
        }

        return rel;
      }

      function handlePointer(event) {
        var point = event.touches ? event.touches[0] : event;
        render(angleToTemp(angleFromPoint(point.clientX, point.clientY)));
      }

      function startDrag(event) {
        dragging = true;
        handlePointer(event);
        event.preventDefault();
      }

      function moveDrag(event) {
        if (!dragging) return;
        handlePointer(event);
      }

      function endDrag() {
        dragging = false;
      }

      handle.addEventListener('pointerdown', startDrag);
      track.addEventListener('pointerdown', startDrag);
      fill.addEventListener('pointerdown', startDrag);
      window.addEventListener('pointermove', moveDrag);
      window.addEventListener('pointerup', endDrag);

      handle.addEventListener('keydown', function (event) {
        var step = 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
          render(current + step);
          event.preventDefault();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
          render(current - step);
          event.preventDefault();
        } else if (event.key === 'Home') {
          render(min);
          event.preventDefault();
        } else if (event.key === 'End') {
          render(max);
          event.preventDefault();
        }
      });

      render(current);
    }

    document.querySelectorAll('.temp-dial-widget').forEach(initDial);
  })();

  } catch(e) { console.error(e); }
})();
})();
